import { Radio, RadioGroup } from 'ui';

import { useTranslation } from '@/i18n/client';
import { useProductList } from '@/modules/product/context/productList';

import { SortingOptionsProps } from './types';

export const SortingOptions = ({
  sidebarSort,
  setSidebarSort,
}: SortingOptionsProps) => {
  const { categorySlug } = useProductList();
  const { t } = useTranslation(['products']);

  const handleSortingChange = (value: string) => {
    const ascending = value.charAt(0);
    const orderBy = value.substring(1);

    setSidebarSort(`${ascending}${orderBy}`);
  };

  return (
    <RadioGroup value={sidebarSort} onChange={handleSortingChange}>
      {categorySlug !== 'search' && (
        <Radio
          value="0sales_ratio"
          position="start"
          labelClassName="sortingOption"
        >
          {t('productList.default')}
        </Radio>
      )}
      {/* <Radio
        value="0updated_at"
        position="start"
        labelClassName="sortingOption"
      >
        {t('productList.latest')}
      </Radio> */}
      <Radio value="1name" position="start" labelClassName="sortingOption">
        {t('productList.aToZ')}
      </Radio>
      <Radio value="0name" position="start" labelClassName="sortingOption">
        {t('productList.zToA')}
      </Radio>
      <Radio value="1price" position="start" labelClassName="sortingOption">
        {t('productList.leastExpensive')}
      </Radio>
      <Radio value="0price" position="start" labelClassName="sortingOption">
        {t('productList.mostExpensive')}
      </Radio>
    </RadioGroup>
  );
};
